import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { FundDetailsService } from '../../services/fund-details/fund-details';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

export const fundDetailsGuard: CanActivateFn = (route): Observable<boolean> => {
  const router = inject(Router);
  const fundDetailsService = inject(FundDetailsService);
  const fundUuid = route.paramMap.get('fundUuid');

  const navigateToFundManagement = (): void => {
    router.navigate([ROUTE_PATHS.FUND_MANAGEMENT]);
  };

  if (!fundUuid) {
    navigateToFundManagement();
    return of(false);
  }

  // Check if navigation is from expand (bypass guard in this case)
  const navigation = router.currentNavigation();
  const bypassGuard = navigation?.extras?.state?.['bypassGuard'];

  if (bypassGuard) {
    return of(true);
  }

  return fundDetailsService.isFundDrafted(fundUuid).pipe(
    map(isDrafted => {
      if (isDrafted) {
        navigateToFundManagement();
        return false;
      }
      return true;
    }),
    catchError(() => {
      navigateToFundManagement();
      return of(false);
    })
  );
};
